export default "__VITE_ASSET__IbPVDTAU__"